<template>
  <div>
    <div class="meeting-info">
      <div class="font-size-small line-height-single">
        <strong>{{ bookingTimes }}</strong>
        <span class="reservation-time" v-if="hasConnectedBookings">
          ({{ formatBookingTimes(reservationStart, reservationEnd) }})
        </span>
      </div>
      <div class="font-size-medium meeting-title">{{ bookingTitle }}</div>
      <div class="font-size-medium text-color-secondary meeting-organizer" v-if="bookingOwnerName">
        {{ bookingOwnerName }}
      </div>
    </div>
    <template v-if="!hasEnded && canInteract">
      <div :class="{adhoc: !bookingOwnerName}" class="actions" v-if="checkedIn">
        <time-buttons :free-mins="freeMinutes" :loading="extendLoading" @time="extend" v-if="canExtend">
          Extend
        </time-buttons>
        <default-button class="extend" disabled v-else>Extend</default-button>
        <default-button :loading="bookingActionInProgress" @click="release" class="check-out" color="red">
          Check Out
        </default-button>
      </div>
      <default-button :loading="bookingActionInProgress" @click="checkIn" class="check-in" color="orange" v-else>
        Check In
      </default-button>
    </template>
  </div>
</template>

<script>
import * as booking from '@/mixins/booking';
import {mapActions, mapGetters} from 'vuex';
import DefaultButton from './DefaultButton';
import TimeButtons from './TimeButtons';

export default {
  name: 'CurrentMeeting',
  components: {TimeButtons, DefaultButton},
  mixins: [booking.forProperty('currentBooking')],
  data() {
    return {
      extendLoading: false
    };
  },
  computed: {
    ...mapGetters('bookings', ['currentBooking']),
    ...mapGetters('config', ['readOnlyMode']),
    canInteract() {
      return !this.readOnlyMode && this.isApproved;
    },
    canExtend() {
      return this.freeMinutes >= 15;
    }
  },
  methods: {
    ...mapActions('bookings', ['extendBooking']),
    extend(mins) {
      this.extendLoading = true;
      this.extendBooking({booking: this.currentBooking, mins})
          .catch(err => {
            this.$logger.error(err);
            this.$notify.showError('Error extending meeting, please try again');
          })
          .finally(() => {
            this.extendLoading = false;
          });
    }
  }
};
</script>

<style scoped>
.meeting-info {
  max-width: calc(10 * var(--grid-size));
}

.meeting-title {
  line-height: 1.4em;
  max-height: 2.8em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.meeting-organizer {
  line-height: 1.4em;
}

.actions,
.check-in {
  margin-top: 10px;
  /*--vertical-grid-offset: 2;
  position: absolute;
  top: calc(var(--vertical-grid-offset) * var(--grid-size));*/
}

.actions {
  width: calc(2 * var(--button-width) + 16px);
}

.actions.adhoc {
  top: calc((var(--vertical-grid-offset) * var(--grid-size)) - var(--button-height));
}

.check-out {
  margin-left: 16px;
}

.reservation-time {
  opacity: 0.5;
  font-weight: normal;
}
</style>
